import { Table, Tabs } from "antd";
import { protectedResources } from "config/msalConfig";
import execute from "hooks/execute";
import { useEffect, useState } from "react";
import CustomerUserData from "../CustomerUsers/CustomerUserData";


const OrgModuleData = ({customer, highlightUserId}) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const columns = [
        {
            title: 'Module Name',
            dataIndex: 'ModuleName',
            key: 'ModuleName',
            sorter: (a, b) => a.ModuleName.toString().localeCompare(b.ModuleName.toString())
        }];



    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await execute('GET', `${protectedResources.api.baseEndPoint}/organizations/${customer.Org_ID}/modules`);
                console.log('response', response);
                if (response.success && response.data.length > 0) {
                    var data = response.data;
                    data.sort((a, b) => a.Order > b.Order);
                    setData(data);
                } else {
                    setData([]);
                }
                setLoading(false);
            } catch (err) {
                console.error('Failed to fetch data:', err);
                setLoading(false);
            }
        };
        console.log(customer);
        if(customer){
            fetchData();
        }
    }, [customer]);

    const tabItems = [
        {
            key: 'customerUsers',
            label: 'Customer Users',
            children: <CustomerUserData customer={customer} highlightUserId={highlightUserId} />
        },
        {
            key: 'modules',
            label: 'Modules',
            children: (
                <Table
                    rowKey={record => record.Id}
                    columns={columns}
                    dataSource={data}
                    loading={loading}
                    pagination={false}
                    size="small" />
            )
        }
    ];

    return (
        <div style={{ padding: '16px', backgroundColor: '#fafafa' }}>
            <Tabs
                defaultActiveKey="customerUsers"
                items={tabItems}
                type="card" />
        </div>
    );

}

export default OrgModuleData;